
export const FIELD_TYPE_CHOICE = 'choice'
export const FIELD_TYPE_DATETIME = 'datetime'
export const FIELD_TYPE_FILE = 'file'
export const FIELD_TYPE_INPUT = 'input'
export const FIELD_TYPE_NOINPUT = 'noinput'

export const FIELD_TYPE_HAS_ENTRIES = [ FIELD_TYPE_CHOICE, FIELD_TYPE_DATETIME, FIELD_TYPE_FILE, FIELD_TYPE_INPUT ]
export const FIELD_TYPE_HAS_PLACEHOLDER = [ FIELD_TYPE_DATETIME, FIELD_TYPE_INPUT ]
